import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { cgiModeMap } from '@/service/const';
import { useEnv } from '@/utils/env';
import { getQueryString } from '@tencent/aix-design';

const { env } = useEnv();
const cgiMode: string = getQueryString('cgiMode') || env.value;

const PVIDKEY = 'imarket-pvid';
const REWRITETIME = 100 * 24 * 60 * 60 * 1000;
const EXPIRES = 50 * 365;

function genPVID(): string {
  return ((Math.round((Math.random() || 0.5) * 2147483647) * +new Date()) % 10000000000) + dayjs().format('YYMMDDHH');
}

function setPVID(pvid = genPVID()) {
  Cookies.set(PVIDKEY, pvid, {
    expires: EXPIRES,
    domain: cgiModeMap[cgiMode as keyof typeof cgiModeMap],
  });
  return pvid;
}

function checkAndReWrite() {
  if (typeof window.cookieStore !== 'undefined') {
    window.cookieStore.get(PVIDKEY).then((data: any) => {
      if (data && data.expires - Date.now() < REWRITETIME) {
        setPVID(data.value);
      }
    });
  }
}

/**
 * 获取pvid
 * @param checkDie 是否需要检查过期，默认不需要
 */
export const getPVID = (checkDie = false) => {
  const key = Cookies.get(PVIDKEY);
  if (key) {
    checkDie && checkAndReWrite();
    return key;
  }
  return setPVID();
};
